import Tool from "../tool.js";
export function auth() {
  let appID = "";
  let url = window.location.href;
  if (url.indexOf("hansdata.com") > -1) {
    appID = "wx6eb720a2c4113a51"; // KSF
  } else {
    appID = "wx751474581710f675"; //
  }
  let state = "h5"; // 状态标识（用于项目拓展）
  let strUrl = "";
  let openid = localStorage.getItem("openid");
  if (Tool.isEmpty(openid)) {
    strUrl =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      appID +
      "&redirect_uri=" +
      encodeURIComponent(window.location.href.replace(/code=(\S)*&state=h5(&?)/, '')) +
      "&response_type=code&scope=snsapi_userinfo&state=" +
      state +
      "#wechat_redirect";
  } else {
    strUrl =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      appID +
      "&redirect_uri=" +
      encodeURIComponent(window.location.href.replace(/code=(\S)*&state=h5(&?)/, '')) +
      "&response_type=code&scope=snsapi_userinfo&state=" +
      state +
      "#wechat_redirect";
  }
  window.location.href = strUrl;
};

export function login(type) {
  // type  a非稽查    b稽查
  let apiStr = type === 'a' ? "/WehPubCtrl/login":"/WehPubCtrl/checkerLogin"
  return new Promise((resolve,rej) => {
    let code = Tool.getUrlKey("code", window.location.href);
    Tool.$http.request(apiStr, {code: code}
    ).do(resp => {
      if(resp.code === 100){
        localStorage.setItem('code', code);
        localStorage.setItem('token', resp.cont.list.token);
        localStorage.setItem('openid', resp.cont.list.openid_us);
        localStorage.setItem('nickname', resp.cont.list.nickname_us);
        localStorage.setItem('headimg', resp.cont.list.headimg_us);
        localStorage.setItem('loginId', resp.cont.list.loginId);
        localStorage.setItem('lastUsetType', type);
        resolve(resp.cont);
      }else{
        rej()
      }
    });
  })
};



// WEBPACK FOOTER //
// ./src/other/utils/auth.js